import NavigationBar from './NavigationBar';

export default NavigationBar;


// WEBPACK FOOTER //
// ./src/components/NavigationBar/index.js